import React from "react";
import Link from "next/link";
import styled from "styled-components";

const Connector = styled.p.attrs({
  className: "text-md font-bold mt-2 mb-1 mx-1",
})`
  font-family: ${(props) => props.theme.fonts.poppins};
`;

const AuthorName = styled.a.attrs({
  className: "text-md font-bold mt-2 mb-1 cursor-pointer",
})`
  font-family: ${(props) => props.theme.fonts.poppins};

  :hover {
    color: ${(props) => props.theme.colors.orange};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    color: ${(props) => props.theme.colors.orange};
  }
`;

export default ({ authorSlug, children, connector }) => (
  <>
    <Connector> {connector} </Connector>
    <Link href="/author/[slug]" as={`/author/${authorSlug}`} passHref>
      <AuthorName>{children}</AuthorName>
    </Link>
  </>
);
